var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9827,
    cy: 21.9827,
    r: 21.9827,
    fill: "#FFDBD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1835 29.5163C24.6893 30.6129 23.1936 31.4129 22.0177 31.8036C18.3167 30.5738 11.4434 25.2866 11.4434 19.4707C11.4434 16.2587 14.0473 13.6548 17.2593 13.6548C19.2261 13.6548 20.9656 14.6313 22.0177 16.126C22.5541 15.3622 23.2666 14.7389 24.0949 14.3087C24.9232 13.8786 25.8429 13.6543 26.7762 13.6548C29.9882 13.6548 32.5921 16.2587 32.5921 19.4707C32.5921 20.3944 32.4187 21.3043 32.1125 22.1867",
    stroke: "#E53935",
    strokeWidth: 1.92831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6038 25.287H25.7186L27.3048 23.1721L28.8909 27.4019L30.457 25.287H32.592",
    stroke: "#E53935",
    strokeWidth: 1.92831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartrate);
export default __webpack_public_path__ + "static/media/heartrate.6ab3d3155711cdb521b5ecbbbe4e81d3.svg";
export { ForwardRef as ReactComponent };